import Cookies from 'universal-cookie'
import { getJwtCookieName } from './getJwtCookieName'

const cookies = new Cookies()

const getJwtCookie = () => cookies.get(getJwtCookieName())

export default getJwtCookie
